import React, { useContext, useState } from "react";

const RegionDataContext = React.createContext();
export const RegionDataProvider = ({ children }) => {
  const [selectedRegion, setSelectedRegion] = useState(null);

  return (
    <RegionDataContext.Provider value={{ selectedRegion, setSelectedRegion }}>
      {children}
    </RegionDataContext.Provider>
  );
};

export default function useRegion() {
  const context = useContext(RegionDataContext);
  return context;
}
